


























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import { getNewsListByCate } from './api';
import { wxShareInfo, isMobile } from '@/common/ts/common';

Vue.use(List);

@Component
export default class Home extends Vue {
  activeTabIndex = 0;
  navList = [
    {
      id: 2,
      text: '动态资讯',
    },
    {
      id: 3,
      text: '典型案例',
    },
    {
      id: 4,
      text: '法律法规',
    },
    {
      id: 5,
      text: '风险提示',
    },
  ];
  queryArr = ['info', 'case', 'law', 'risk'];
  newsList: any[] = [];
  loading = false;
  finished = false;
  page = 1;
  error = false;

  @Watch('activeTabIndex')
  onActiveTabIndexChange(newval: number) {
    this.resetNewsList();
    this.getNewsList();
  }

  created() {
    this.getNewsList();
    this.$addPv(393);
    // 处理微信分享
    wxShareInfo({
      title: '打击非法集资 川渝在行动',
      subtitle: '',
    });
  }
  async getNewsList() {
    if (this.finished) {
      return console.log('没有更多了');
    }
    this.loading = true;
    try {
      const ret: any = await getNewsListByCate(
        this.queryArr[this.activeTabIndex],
        {
          page: this.page,
        },
      );
      this.loading = false;
      this.newsList = [...this.newsList, ...ret.data];
      this.page++;
      console.log(ret);
      if ((!ret.data && !ret.data.length) || !ret) {
        this.finished = true;
      }
    } catch (err) {
      console.log('异常报告', err);
      this.error = true;
    }
  }
  resetNewsList() {
    this.finished = false;
    this.newsList = [];
    this.page = 1;
  }
  onNavChange(tabIndex: number) {
    this.activeTabIndex = tabIndex;
  }
  onJumpToDetail(newsItem: any) {
    if (window.udid && newsItem.dataType !== 7 && newsItem.dataType !== 5) {
      const { id, classId, isVideo } = newsItem;
      const option = {
        dt: isVideo ? 9 : 3,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = newsItem.targetUrl;
    }
  }
  beforeRouteEnter(to: any, from: any, next: any) {
    const pcUrl = 'https://www.cqcb.com/topics/2020strikeIllegal/index.php';
    if (!isMobile()) {
      console.log('is pc platform');
      location.href = pcUrl;
    } else {
      next();
    }
  }
}
